module.exports = __webpack_public_path__ + "static/media/img-email-automatica.cf747f88.jpg";